import Color from 'color';
import { toLowerCase } from './string.utils';
export var COLOR_HEX_CODE_REGEX = /^#([A-F0-9]{6}|[A-F0-9]{3})$/i;
export var COLOR_HEX_CODE_WITH_ALPHA_REGEX = /^#([A-F0-9]{8}|[A-F0-9]{4})$/i;
export var DefaultColorPalette = {
    red: '#F7472F',
    crimson: '#AA0E0E',
    firebrick: '#C65D4F',
    redOrange: '#FF5E19',
    orange: '#FF9519',
    yellow: '#F0AE1E',
    gold: '#CEA046',
    brown: '#A65A2F',
    grassGreen: '#A2CF20',
    matcha: '#7B9939',
    green: '#2DC333',
    emerald: '#007931',
    neonGreen: '#1BE9B8',
    blueGreen: '#04A789',
    teal: '#28CFCF',
    lightBlue: '#76C7C2',
    skyblue: '#009FE3',
    skyblueLighter: '#2FCCFD',
    persianBlue: '#096891',
    blue: '#1F78FF',
    navy: '#1E46AE',
    brightPurple: '#5E5BE5',
    purple: '#6464AF',
    deepPurple: '#4A4181',
    lavender: '#A897EC',
    violet: '#7F44DF',
    royalPurple: '#431D82',
    magenta: '#F51B5C',
    plum: '#8E3163',
    pink: '#DE7EA1',
    white: '#ffffff',
    lightGray: '#D2DDE1',
    mediumGray: '#7D8389',
    steel: '#566A83',
    darkGray: '#363F47',
    shadow: '#0E0D35',
    black: '#000000',
    pastelBlue: '#009FE34D',
    pastelGold: '#FDC4304D',
    pastelTeal: '#3ADFB74D',
    pastelPurple: '#D747EF4D',
};
export function isColorHexCode(input) {
    if (!input)
        return false;
    return COLOR_HEX_CODE_REGEX.test(input + '');
}
;
export var CSSColorKeywords = ['inherit', 'transparent', 'currentColor'];
export var isCSSColorKeyword = function (s) {
    if (!s)
        return false;
    return CSSColorKeywords.includes(s);
};
export var withOpacity = function (color, opacity) {
    if (!color)
        return undefined;
    if (isCSSColorKeyword(color))
        return color;
    try {
        return Color(color).alpha(opacity).rgb().string();
    }
    catch (e) {
        console.warn("The color " + color + " supplied to withOpacity() is not in a valid color format.");
        return color;
    }
};
export function isHexCode(input) {
    if (!input)
        return false;
    return /^#[0-9A-F]{6}$/i.test(input) || /^#[0-9A-F]{3}$/i.test(input) || /^#[0-9A-F]{8}$/i.test(input);
}
export var isBrightColor = function (colorHex) { return colorHex ? Color(colorHex || '#000').luminosity() >= .48 : false; };
export function getContrastColorHex(colorHex) {
    return isBrightColor(colorHex) ? DefaultColorPalette.deepPurple : DefaultColorPalette.white;
}
export var getColorHexByName = function (colorName, fallback) { var _a, _b, _c; return (_c = (_b = (_a = (colorName ? DefaultColorPalette[colorName] : colorName)) !== null && _a !== void 0 ? _a : fallback) !== null && _b !== void 0 ? _b : colorName) !== null && _c !== void 0 ? _c : DefaultColorPalette.skyblue; };
export function getContextColorStyle(contextColorName, color, namespace) {
    var _a, _b;
    if (namespace === void 0) { namespace = 't2'; }
    if (!contextColorName || !color) {
        // console.warn('useContextColorStyle must be supplied with both a context color name and color name.');
        return {};
    }
    var colorName = toLowerCase(contextColorName);
    if (isHexCode(color)) {
        var colorObj = Color(color);
        var h = colorObj.hue();
        var s = colorObj.saturationl() + '%';
        var l = colorObj.lightness() + '%';
        var contrastColor = Color(getContrastColorHex(color));
        var ch = contrastColor.hue();
        var cs = contrastColor.saturationl() + '%';
        var cl = contrastColor.lightness() + '%';
        return _a = {},
            _a["--" + namespace + "-c-" + colorName + "-h"] = h,
            _a["--" + namespace + "-c-" + colorName + "-s"] = s,
            _a["--" + namespace + "-c-" + colorName + "-l"] = l,
            _a["--" + namespace + "-c-" + colorName + "-hsl"] = [h, s, l].join(','),
            _a["--" + namespace + "-c-" + colorName + "_h"] = ch,
            _a["--" + namespace + "-c-" + colorName + "_s"] = cs,
            _a["--" + namespace + "-c-" + colorName + "_l"] = cl,
            _a["--" + namespace + "-c-" + colorName + "_hsl"] = [ch, cs, cl].join(','),
            _a;
    }
    else {
        return _b = {},
            _b["--" + namespace + "-c-" + colorName + "-h"] = "var(--" + namespace + "-c-" + color + "-h)",
            _b["--" + namespace + "-c-" + colorName + "-s"] = "var(--" + namespace + "-c-" + color + "-s)",
            _b["--" + namespace + "-c-" + colorName + "-l"] = "var(--" + namespace + "-c-" + color + "-l)",
            _b["--" + namespace + "-c-" + colorName + "-hsl"] = "var(--" + namespace + "-c-" + color + "-hsl)",
            _b["--" + namespace + "-c-" + colorName + "_h"] = "var(--" + namespace + "-c-" + color + "_h)",
            _b["--" + namespace + "-c-" + colorName + "_s"] = "var(--" + namespace + "-c-" + color + "_s)",
            _b["--" + namespace + "-c-" + colorName + "_l"] = "var(--" + namespace + "-c-" + color + "_l)",
            _b["--" + namespace + "-c-" + colorName + "_hsl"] = "var(--" + namespace + "-c-" + color + "_hsl)",
            _b;
    }
}
